import { Expose } from "class-transformer";

export class UpdateModelDto {
  @Expose()
  name: string;

  @Expose()
  manufacturerId: string;
}
